import type { BaseCommandMenuItem, WorkflowState } from '@/domains/command-center/types'

import { formatBarcodesForDisplay } from '@/domains/command-center/utils/barcodeUtils'
import { useLocales } from '@/locales/useLocales'

const getPlaceholder = (state: WorkflowState): string => {
  if (state.mode === 'awaitingParentProduct') {
    return 'Enter parent product name or SKU'
  }
  return useLocales().quickDictionary.value.inputs.command_center
}

const getCancelAction = (resetWorkflow: () => void) => {
  return {
    id: 'action-cancel-add-variants',
    type: 'action' as const,
    label: 'Cancel Adding Variants',
    icon: 'cancel',
    execute: resetWorkflow
  }
}

const getPendingBarcodesHeader = (barcodes: string[]): BaseCommandMenuItem => {
  return {
    id: 'header-pending-barcodes',
    type: 'header',
    label: `Adding Barcodes: ${formatBarcodesForDisplay(barcodes)}`,
    disabled: true
  }
}

export { getPlaceholder, getCancelAction, getPendingBarcodesHeader }
